export default "__VITE_ASSET__BBXg0oNr__"